"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPPInvitation = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.SPPInvitation = typebox_1.Type.Object({
    vendor_name: typebox_1.Type.String(),
    sign_up_link: typebox_1.Type.String(),
});
//# sourceMappingURL=spp-invitation.js.map